import { resolveToBrandkitVideoIfNeeded } from "../helpers/itemsHelper";
import { VideoScene } from "../types";
import { useAssetHasAudio } from "./useAssetHasAudio";
import { useTemplateData } from "./useTemplateData";

/** Whether the video sound of an intro/outro scene can be turned on. */
export const useSceneVideoSound = (scene: VideoScene | undefined) => {
  const {
    brandKitData: { intro: brandKitIntro, closing: brandKitClosing },
  } = useTemplateData();

  const { hasAudio } = useAssetHasAudio(
    resolveToBrandkitVideoIfNeeded(
      scene?.assetId,
      brandKitIntro,
      brandKitClosing
    )
  );
  return { hasAudio, canPlaySound: hasAudio === true };
};
